import { render } from "./AdminPermission.vue?vue&type=template&id=643eb46a&scoped=true"
import script from "./AdminPermission.vue?vue&type=script&lang=js"
export * from "./AdminPermission.vue?vue&type=script&lang=js"

import "./AdminPermission.vue?vue&type=style&index=0&id=643eb46a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643eb46a"]])

export default __exports__